import { render, staticRenderFns } from "./GlobalDocumentComponent.vue?vue&type=template&id=9b60f932&scoped=true"
import script from "./GlobalDocumentComponent.vue?vue&type=script&lang=js"
export * from "./GlobalDocumentComponent.vue?vue&type=script&lang=js"
import style0 from "./GlobalDocumentComponent.vue?vue&type=style&index=0&id=9b60f932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b60f932",
  null
  
)

export default component.exports